import { ShopInfo } from '../data/fetchSettings';

// The <title> the page shipped with (per-shop index.html: "<Name> - Menu", or the one
// seo_render baked), read before anything changes it.
const SHIPPED_TITLE = typeof document !== 'undefined' ? document.title : '';

export function brandName(info: ShopInfo, shippedTitle: string = SHIPPED_TITLE): string {
  if (info.shopName && info.shopName.trim()) return info.shopName.trim();
  // Same suffix rule as seo_render.shop_name_from.
  return shippedTitle.replace(/\s*[-–—|]\s*(Menu|Μενού).*$/i, '').trim();
}

/**
 * Per-branch <title> and canonical, so a rendered branch page is its own document for search.
 * When the page is the per-branch SEO document seo_render writes (/_b/<slug>.html, already
 * canonical to this branch), its richer title is kept as is.
 */
export function applyBranchHead(brand: string, branch: { slug: string; name: string }): void {
  const href = `https://${window.location.host}/${branch.slug}`;
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (link && link.getAttribute('href') === href) return;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
  document.title = `${brand} ${branch.name}`.trim() + ' — Μενού';
}

export const LAST_BRANCH_KEY = 'menulynx.lastBranch';

export function rememberBranch(slug: string): void {
  try {
    localStorage.setItem(LAST_BRANCH_KEY, slug);
  } catch {
    /* private mode / storage disabled — non-fatal */
  }
}

export function lastBranch(): string | null {
  try {
    return localStorage.getItem(LAST_BRANCH_KEY);
  } catch {
    return null;
  }
}
